var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerBg"},[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"center"},[_vm._v(" 山西青峰软件股份有限公司技术支持 ")])])])}]

export { render, staticRenderFns }